$ ->
	$pageNotFound = $ '.section-404'
	unless $pageNotFound.length > 0
		return

	$switcherScenes = $pageNotFound.find '.switcher-scenes'
	$breakerElement = $switcherScenes.find '.breaker'
	$lightOffOverlay = $pageNotFound.find '.light-off'

	$breakerElement.on 'click', ->
		$this = $ this
		$this.css 'top', '0'

		setTimeout ->
			$switcherScenes.fadeOut 300
			$lightOffOverlay.fadeOut 1500
		, 300


/** WEBPACK FOOTER **
 ** ./assets/coffee/pages/404.coffee
 **/